var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreeview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 83,
    viewBox: "0 0 86 83",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49695 14.3091V65.7565C1.15681 70.8588 5.60708 72.1343 7.87473 72.1343H10.0007M1.49695 14.3091C1.63867 12.4667 3.11263 8.78174 7.87473 8.78174H44.4406C46.5666 8.78174 50.8184 9.88722 50.8184 14.3091V24.5136M1.49695 14.3091C1.63867 16.1516 3.11263 19.8365 7.87473 19.8365H10.0007M50.8184 24.5136V65.7565C50.8184 67.7407 49.7129 71.7942 45.291 72.1343H10.0007M50.8184 24.5136C50.1381 20.772 46.2831 19.8365 44.4406 19.8365H10.0007M10.0007 19.8365V72.1343M5.74884 14.3091H7.87473M11.2762 14.3091H46.5666",
    stroke: "#48576D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6539 36.4192H15.1028V27.9155H45.2909V36.4192H42.7398M17.6539 36.4192V41.5214H42.7398V36.4192M17.6539 36.4192H42.7398",
    stroke: "#48576D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6539 50.0252H15.1028V41.5215H45.2909V50.0252H42.7398M17.6539 50.0252V55.1274H42.7398V50.0252M17.6539 50.0252H42.7398",
    stroke: "#48576D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1028 63.6311V55.1274H45.2909V63.6311H42.7398H17.6539H15.1028Z",
    stroke: "#48576D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6525 7.50635H66.5503C64.9913 7.64808 61.8733 8.86694 61.8733 12.6086V71.2841C62.015 72.5597 63.1488 75.9611 66.5503 75.9611H71.6525",
    stroke: "#48576D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8733 28.3403H72.5029",
    stroke: "#48576D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8733 54.2769H72.5029",
    stroke: "#48576D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2437 41.5215H61.8733",
    stroke: "#48576D",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9185 0.307129H72.4399V13.7857H85.9185V0.307129Z",
    fill: "#22A081"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9185 22.5073H72.4399V35.9859H85.9185V22.5073Z",
    fill: "#FAFAFA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9185 47.0859H72.4399V60.5645H85.9185V47.0859Z",
    fill: "#22A081"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9185 69.2856H72.4399V82.7642H85.9185V69.2856Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeview);
export default __webpack_public_path__ + "static/media/treeview.18b04d1097c67e4e5ea7dc04eb8ab039.svg";
export { ForwardRef as ReactComponent };